$(".index-version-video-content-button").click(function(){
    $('.index-version-video-modal').css({'display': 'block'});
  })
  $('.index-version-video-modal-close').click(function(){
    $('.index-version-video-modal').css({'display': 'none'});
  })
  // var sTimer = setInterval(moveSlide,1000);
  // function moveSlide(){
  //     console.log(123)
  // };

  var spLength = $('.index-version-slide-nav p').length,
		scimgWidth = $(window).width(),
		sulWidth = scimgWidth * spLength,
		sNum = 0;
		$(".index-version-slide ul").width(sulWidth);
		$(".index-version-slide ul li").width(scimgWidth);
  
    var sTimer = setInterval(moveSlide,3000);
	function moveSlide(){
		if (sNum > spLength-1) {
			sNum = 0;
		};
		showPics(sNum);
		sNum++;
	};

    // 点击nav
	$('.index-version-slide-nav p').click(function(){
        //clearInterval(sTimer);
        sNum = $(this).index();
        showPics(sNum);
    });
    // 点击dot
	$('.index-version-slide-dot p').click(function(){
        //clearInterval(sTimer);
        sNum = $(this).index();
        showPics(sNum);
    });
    function showPics(sNum){
		$(".index-version-slide-nav p").eq(sNum).addClass("index-slide-nav-active").siblings().removeClass("index-slide-nav-active");
		$(".index-version-slide-dot p").eq(sNum).addClass("index-slide-dot-active").siblings().removeClass("index-slide-dot-active");
		$(".index-version-slide ul").animate({
			"margin-left" : -scimgWidth * sNum 
		});
	}